<template>
    <div>
        <div class="form-group col-12">
            <label for="name">Name</label>

            <input
                id="name"
                v-model="hug.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
                dir="auto"
                placeholder="Name"
            />

            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label for="name">Name in english</label>

            <input
                id="nameEng"
                v-model="hug.nameEng"
                type="text"
                class="form-control"
                dir="auto"
                placeholder="Name in english"
            />
        </div>

        <div class="form-group col-4">
            <label for="number">Number</label>

            <input
                id="number"
                v-model="hug.number"
                type="number"
                class="form-control"
                :class="{
                    'is-invalid': hasError('number')
                }"
                placeholder="Number"
            />

            <div class="invalid-feedback">
                {{ getError('number') }}
            </div>
        </div>

        <div class="col-4 form-group">
            <label for="name">Year</label>

            <input
                v-model="hug.year"
                class="form-control"
                :class="{
                    'is-invalid': hasError('year')
                }"
                type="number"
                min="1900"
                max="2099"
                step="1"
                placeholder="Year"
            />

            <div class="invalid-feedback">
                {{ getError('year') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        },
        editMode: {
            type: Boolean,
            required: true
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            hug: {}
        };
    },

    watch: {
        hug() {
            this.$emit('input', this.hug);
        }
    },

    created() {
        this.hug = { ...this.value };
    },

    methods: {
        hasError(key) {
            return (
                this.validation.hug[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.hug,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
